module.exports = __webpack_public_path__ + "static/img/FAQ_page top img_desktop.4d9c2b75.jpg";